import axios from "axios";
import { webApiMenuLateral } from "../routes/endpoints";

export const getMenuLateralByIdData = async (id: string) => {
    const res = await axios.post(webApiMenuLateral, { id: id });
    const { data } = res;
    return data;
  };